"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";

/** The V2 legal footer: copyright and the three legal routes. Rendered in `AuthShell`'s `footer` slot. */
export function V2Footer() {
  const t = useTranslations("AuthThemePage");
  return (
    <div className="text-auth-mute dark:text-auth-on-ink-mute flex flex-col items-center justify-between gap-3 px-5 py-4 text-center text-xs sm:flex-row sm:px-8 lg:px-13">
      <p>{t("footer.copyright")}</p>
      <nav aria-label={t("footer.legal")} className="flex flex-wrap justify-center gap-x-4 gap-y-2">
        <Link href="/privacy" className="hover:text-auth-text dark:hover:text-auth-on-ink">
          {t("footer.privacy")}
        </Link>
        <Link href="/terms" className="hover:text-auth-text dark:hover:text-auth-on-ink">
          {t("footer.terms")}
        </Link>
        <Link href="/sms-terms" className="hover:text-auth-text dark:hover:text-auth-on-ink">
          {t("footer.smsTerms")}
        </Link>
      </nav>
    </div>
  );
}
